// What a form field shows for an error. Bosnian shows the server's message,
// exactly as before. English translates the API's own error codes, which the
// API always words in Bosnian; Django's built-in validation messages need no
// help, because the API already wrote them in the request's language.
export function fieldErrorText(error, language, i18n) {
	if (!error) return "";
	const key = error.code ? `errors:field.${error.code}` : null;
	// `lng` makes the answer follow the language we were asked about, not
	// whatever i18n happens to be set to.
	if (language === "en" && key && i18n.exists(key, { lng: language })) {
		return i18n.t(key, { lng: language });
	}
	return error.message ?? "";
}
